import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tooltip, {
    content: _ctx.$t('VIEW_MODE.CARDS'),
    placement: "bottom",
    "visible-arrow": false,
    "auto-close": 2000
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, [(_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 34 34",
      class: _normalizeClass({
        'selected': $props.modelValue === $setup.viewModeEnum.ICON,
        'disabled': $props.disabled
      }),
      onClick: _cache[0] || (_cache[0] = $event => $setup.setViewMode($setup.viewModeEnum.ICON))
    }, _cache[2] || (_cache[2] = [_createElementVNode("use", {
      "xlink:href": "#tile"
    }, null, -1)]), 2))])]),
    _: 1
  }, 8, ["content"]), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('VIEW_MODE.DETAILS'),
    placement: "bottom",
    "visible-arrow": false,
    "auto-close": 2000
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, [(_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 34 34",
      class: _normalizeClass({
        'selected': $props.modelValue === $setup.viewModeEnum.DETAILS,
        'disabled': $props.disabled
      }),
      onClick: _cache[1] || (_cache[1] = $event => $setup.setViewMode($setup.viewModeEnum.DETAILS))
    }, _cache[3] || (_cache[3] = [_createElementVNode("use", {
      "xlink:href": "#list"
    }, null, -1)]), 2))])]),
    _: 1
  }, 8, ["content"])]);
}